var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title !== null)?_c('span',{staticClass:"title text-lg uppercase",class:_vm.colorScheme},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }